<template>
    <div></div>
</template>

<script>
    export default {
        mounted() {
            localStorage.clear();
            location.href = '/pages/login'
        }
    }
</script>